<!-- eslint-disable @angular-eslint/template/prefer-ngsrc -->
@if (heroImageData) {
  <ss-www-image-with-loader
    class="w-full aspect-[4/3] md:aspect-[16/8] relative"
    [fileDetail]="heroImageData.image"
    [desktopImageSize]="'full'"
    [priority]="priority"
    [ssDirectus]="{
      collection: 'heroImage',
      item: heroImageData.id,
      fields: ['image', 'altText'],
    }"
  ></ss-www-image-with-loader>
}
@if (heroVideoData()) {
  <div
    class="w-full aspect-video md:aspect-[2/1] relative max-md:mt-[60px] md:flex md:flex-col md:justify-center md:overflow-hidden"
  >
    <div #heroVideo></div>
    @if (heroVideoData()?.videoThumbnail && !videoStartedPlaying()) {
      <img
        [@justFadeOut]
        class="absolute inset-0 object-cover w-full h-full"
        [src]="heroVideoData()!.videoThumbnail"
        [srcset]="thumbnailSrcSet()"
        [sizes]="sizes"
        alt="video preview"
        [ssDirectus]="{
          collection: 'heroVideo',
          item: heroVideoData()!.id,
          fields: ['videoThumbnail', 'altText'],
        }"
      />
    }
    @if (!heroVideoData()?.autoPlay && (playClicked$ | async) === false) {
      <ss-www-play-button-overlay
        [playButtonMessage]="heroVideoData()?.playButtonMessage ?? 'Play Video'"
        (playClicked)="playClicked$.next(true)"
        [ssDirectus]="{
          collection: 'heroVideo',
          item: heroVideoData()!.id,
          fields: ['video', 'autoPlay', 'playButtonMessage'],
        }"
      ></ss-www-play-button-overlay>
    }
  </div>
}

@if (playClicked$ | async) {
  <ss-building-block-pop-up-video
    [vimeoVideoId]="heroVideoData()?.video!"
    (closeVideo)="playClicked$.next(false)"
  />
}
